import { AlertType } from '@interface/common';

export const ALERT: AlertType = 'alert';
export const CONFIRM: AlertType = 'confirm';
